<template>
  <div>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <div v-for="item in list" :key="item.commentId" class="diveCommentRect">
        <div class="icon">
          <van-image
            width="3em"
            height="3em"
            round
            lazy-load
            fit="contain"
            :src="item.userIcon?item.userIcon:'/dive/defaultIcon.jpg'"
          />
        </div>
        <div class="Body">
          <span @click="onSelectCommentInfo(item.commentId)">
            <van-tag v-if="item.isStudent" type="primary" :color="GetDiveMainBack()" style="margin-right:0.5em">顾客</van-tag>
            {{ item.userName }}</span>
            &nbsp;&nbsp;
          <van-rate v-if="item.isScore" v-model="item.score" size="0.9em" allow-half readonly class="star" :color="GetDiveMainBack()" @click="onSelectCommentInfo(item.commentId)" />
          <div @click="onSelectCommentInfo(item.commentId)">{{ item.about }}</div>
          <van-image
            v-for="(img,index) in item.res"
            :key="index"
            class="img"
            width="2.5em"
            height="2.5em"
            fit="cover"
            lazy-load
            :src="img"
            radius="0.3em"
            @click="showPreview(item.res)"
          />

        </div>
      </div>
    </van-list>
    <diveCommentPopup v-model="selectCommentId" :comment-type="selectCommentType" />
  </div>
</template>
<script>
import request from '@/utils/request'
import { List, Image, Lazyload, Rate, Tag, ImagePreview } from 'vant'
import { GetDiveMainBack, GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
import diveCommentPopup from '@/components/diveCommentPopup'
export default {
  components: {
    [List.name]: List,
    [Image.name]: Image,
    [Lazyload.name]: Lazyload,
    [Rate.name]: Rate,
    [Tag.name]: Tag,
    [ImagePreview.name]: ImagePreview,
    diveCommentPopup
  },
  props: {
    // eslint-disable-next-line
    value: undefined,
    // eslint-disable-next-line
    commentType: undefined
  },
  data() {
    return {
      search: {
        limit: 30,
        page: 1,
        type: undefined,
        id: undefined
      },
      loading: undefined,
      finished: false,
      list: [],
      selectCommentId: undefined,
      selectCommentType: undefined
    }
  },
  watch: {
    value(newValue) {
      this.search.id = newValue
      if (newValue) {
        this.init()
      }
    },
    commentType(newValue) {
      this.search.type = newValue
    }
  },
  created() {
    console.log('created onLoad', this.loading)
  },
  methods: {
    GetDiveMainBack,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    init() {
      this.list = []
      this.search.page = 1
      this.finished = false
      this.onLoad()
    },
    showPreview(imgs) {
      ImagePreview(imgs)
    },
    onSelectCommentInfo(commentId) {
      this.selectCommentType = this.search.type
      this.selectCommentId = commentId
    },
    onLoad() {
      console.log('onLoad', this.loading)
      if (this.loading === undefined) {
        // this.loading = true
        console.log('onLoad return')
        return
      }
      this.loading = true
      request({
        url: '/DiveData/getDiveCommentList',
        method: 'post',
        data: this.search
      }).then(response => {
        if (!response.success) {
          this.error = true
          return
        }
        this.loading = false
        this.search.limit = response.data.limit
        this.search.page = response.data.page + 1
        response.data.rows.forEach(item => {
          this.list.push(item)
        })
        if (response.data.rows.length < this.search.limit) {
          this.finished = true
        }
      })
    }

  }
}
</script>

<style scoped>
.diveCommentRect{
    position: relative;
    border-bottom: 1px solid #f5f5f5;
    margin-bottom: 0.5em;
    min-height: 3.5em;
}
.diveCommentRect .icon{
    position: absolute;
    left: 0.5em;
    top: 0;
    width: 4em;
}
.diveCommentRect .Body{
    padding-left: 5em;
}
.diveCommentRect .Body span{
    font-weight: 700;
    font-size: 0.9em;
}
.diveCommentRect .Body div{
    padding: 0.25em 0;
    font-size: 0.8em;
    color: #999;
}
.diveCommentRect .Body .img{
    margin:0.5em 0.5em 0 0;
    overflow: hidden;
}
</style>
